import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule,
	DialogPosition }
	from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NgFor } from '@angular/common';

interface IDialogContent {
	variables: string[];
	left: string;
	bottom: string;
}

@Component({
	selector: 'copo-eorder-dialog-variables',
	templateUrl: './dialog-variables.component.html',
	styleUrl: './dialog-variables.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [

		MatDialogModule,
		TranslateModule,
		NgFor
	],
})
export class DialogVariablesComponent implements OnInit {
	constructor(

		@Inject(MAT_DIALOG_DATA) public dialogContent: IDialogContent,

		private readonly dialogRef: MatDialogRef<DialogVariablesComponent>
	) {}

	ngOnInit() {
		this.dialogRef.updateSize('auto', 'auto');
		const position: DialogPosition = {
			top: `${ this.dialogContent.bottom + 10 }px`,
			left: `${ this.dialogContent.left }px`,
			bottom: 'auto',
			right: 'auto'
		};
		this.dialogRef.updatePosition(position);
	}
}
